import type {ComponentType} from 'react'
import {BultasPage} from './pages/BultasPage'
import {ColorsPage} from './pages/ColorsPage'
import {FoniPage} from './pages/FoniPage'
import {GlyphInspectorPage} from './pages/GlyphInspectorPage'
import {KonstruktorsPage} from './pages/KonstruktorsPage'

export interface RouteDef {
    readonly path: string
    readonly label: string
    readonly component: ComponentType
}

export const ROUTES: readonly RouteDef[] = [
    {path: '/', label: 'Konstruktors', component: KonstruktorsPage},
    {path: '/glifi', label: 'Glifi', component: GlyphInspectorPage},
    {path: '/colors', label: 'Krāsas', component: ColorsPage},
    {path: '/foni', label: 'Foni', component: FoniPage},
    {path: '/bultas', label: 'Bultas', component: BultasPage}
] as const
